import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "icon"]

  connect() {
    document.addEventListener("click", this.handleClickOutside.bind(this))
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside.bind(this))
  }

  toggle(event) {
    event.stopImmediatePropagation()
    this.menuTarget.classList.toggle("hidden")
    this.menuTarget.classList.toggle("flex")

    if (this.hasIconTarget) {
      this.iconTarget.textContent = this.menuTarget.classList.contains("hidden") ? "menu" : "close"
    }
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.menuTarget.classList.remove("flex")

    if (this.hasIconTarget) {
      this.iconTarget.textContent = "menu"
    }
  }

  stopPropagation(event) {
    event.stopImmediatePropagation()
  }

  handleClickOutside(event) {
    if (
      !this.element.contains(event.target) &&
      !this.menuTarget.classList.contains("hidden")
    ) {
      this.close()
    }
  }
}